import { Base64 } from 'js-base64';

const firstLetterOfWord = (word: string) => word?.charAt(0)?.toUpperCase() || '';
const secondLetterOfWord = (word: string) => word?.charAt(1)?.toUpperCase() || '';

export const getInitials = (firstName?: string, lastName?: string) => {
  if (!lastName) return firstLetterOfWord(firstName);
  return [firstLetterOfWord(firstName), firstLetterOfWord(lastName) || secondLetterOfWord(firstName)].join('');
};

export const getFullName = (firstName?: string, lastName?: string) => {
  return [firstName, lastName].filter((a) => a).join(' ');
};

export const getNameAndLastName = (fullName: string) => {
  const [name, lastName] = fullName.split(' ').slice(0, 2);
  return [name || '', lastName || ''];
};

export const getInitialsFromFullName = (fullName: string) => {
  const [memberName, memberLastName] = getNameAndLastName(fullName);
  return getInitials(memberName, memberLastName);
};

export const getInviteLink = (email: string, inviter: string, organizationName: string, organizationId: number) => {
  const dataStringified = JSON.stringify({
    email,
    inviter,
    org: organizationName,
    organizationId,
  });

  return `${process.env.REACT_APP_URL}/signup?invite=${Base64.encode(dataStringified)}&redirect=/app/organizations`;
};
